import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "Record" }
const _hoisted_2 = { style: {"height":"60px","display":"inline-flex","margin":"0 auto"} }
const _hoisted_3 = { style: {"height":"60px","line-height":"60px","text-align":"center","margin-left":"14px"} }

import { searchFormConfig } from './config/search.config'
import { contentTableConfig } from './config/content.config'
import { usePageSearch } from '@/hooks/userPageSearch'
import { getPageListData } from '@/service/main/system'
import { secondToString } from '@/utils/date-format'
import { useRoute } from 'vue-router'
import { useStore } from '@/store'
import dayjs from 'dayjs'
import {initEmptyParam} from "@/hooks/useInitParam";
import localCache from "@/utils/cache";
import {ref} from "vue";
import { ElLoading } from 'element-plus'


export default /*#__PURE__*/_defineComponent({
  __name: 'Record',
  setup(__props) {

initEmptyParam()
let eventData
const getEventList = async () => {
  eventData = await getPageListData('/main/customerEvents/queryByCondition', {
    pageNo: 1,
    pageSize: 1000
  })

  const channels = searchFormConfig.formItems.find(
    (item) => item.field === 'channelId'
  )
  channels!.options = eventData.list.map((item: any) => {
    return { title: item.eventName, value: item.rowId.toString() }
  })
}

getEventList()
const store = useStore()
const userInfo = store.state.login.userInfo

const getEmp = async () => {
  let userList = localCache.getCache('empData')
  const userOptions = userList.map((item: any) => {
    return {title: item.realName, value: item.id};
  })
  const userItem = searchFormConfig.formItems.find((item) => item.field === 'empIds')
  userItem!.options = userOptions;
}
getEmp()

const getDept = () => {
  const dept = searchFormConfig.formItems.find(
    (item) => item.field === 'deptId'
  )
  dept!.isDisabled = userInfo.isManager != '1';
  const deptData = store.state.login.depts
  dept!.options = deptData.map((item: any) => {
    return { title: item.name, value: item.id }
  })
}
getDept()

const route = useRoute()

let queryParam = ref()
if (userInfo.isManager != '1') {
  queryParam.value = {
    empIds: userInfo.id,
    accessTime: [
      dayjs().startOf('date').format('YYYY-MM-DD HH:mm:ss'),
      dayjs().endOf('date').format('YYYY-MM-DD HH:mm:ss')
    ],
    ...route.query
  }
} else {
  queryParam.value = {
    deptId: userInfo.deptId,
    accessTime: [
      dayjs().startOf('date').format('YYYY-MM-DD HH:mm:ss'),
      dayjs().endOf('date').format('YYYY-MM-DD HH:mm:ss')
    ],
    ...route.query
  }
}

store.commit('system/changeQueyryInfo', queryParam.value)

const handleSortChange = (value: any) => {
  console.log(value)
  store.commit('system/changeOrderInfo', {
    orderBy: value.prop,
    orderType: value.order
  })
  const queryInfo = store.state.system.queryInfo
  pageContentRef.value?.getPageData(queryInfo)
}

const resetCb = () => {
  return queryParam.value
}

const [pageContentRef, handleResetClick, handleSearchClick] =
  usePageSearch(resetCb)

// 直接调用 Store 导出 Action，绕过 PageContent 权限检查
const handleDownBtnClick = async () => {
  const loadingInstance = ElLoading.service({
    lock: true,
    text: '数据下载中...',
    background: 'rgba(0, 0, 0, 0.5)'
  })
  try {
    const res = await getPageListData(
      '/main/liveEventAccess/download',
      store.state.system.queryInfo,
      'blob'
    )
    const blob = new Blob([res], { type: 'application/octet-stream' })
    const down = document.createElement('a')
    down.download = '直播访问记录.xlsx'
    down.style.display = 'none'
    down.href = URL.createObjectURL(blob)
    document.body.appendChild(down)
    down.click()
    URL.revokeObjectURL(down.href)
    document.body.removeChild(down)
  } finally {
    loadingInstance.close()
  }
}

return (_ctx: any,_cache: any) => {
  const _component_PageSearch = _resolveComponent("PageSearch")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_link = _resolveComponent("el-link")!
  const _component_el_avatar = _resolveComponent("el-avatar")!
  const _component_PageContent = _resolveComponent("PageContent")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_PageSearch, {
      searchFormConfig: _unref(searchFormConfig),
      onResetBtnClick: _unref(handleResetClick),
      onSearchBtnClick: _unref(handleSearchClick)
    }, null, 8, ["searchFormConfig", "onResetBtnClick", "onSearchBtnClick"]),
    _createVNode(_component_PageContent, {
      ref_key: "pageContentRef",
      ref: pageContentRef,
      contentTableConfig: _unref(contentTableConfig),
      pageName: "liveEventAccess",
      onSortChange: handleSortChange,
      downUrl: "/main/liveEventAccess/download",
      downFilename: "直播访问记录.xlsx",
      onDownBtnClick: handleDownBtnClick
    }, {
      headerHandler: _withCtx(() => [
        _createVNode(_component_el_button, {
          type: "primary",
          size: "medium",
          onClick: _ctx.handleExportClick
        }, {
          default: _withCtx(() => [
            _createTextVNode("导出")
          ]),
          _: 1
        }, 8, ["onClick"])
      ]),
      duration: _withCtx((scope) => [
        _createElementVNode("div", null, _toDisplayString(_unref(secondToString)(scope.row.duration)), 1)
      ]),
      material: _withCtx((scope) => [
        _createVNode(_component_el_link, {
          href: scope.row.url,
          type: "primary",
          target: "_blank"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(scope.row.title), 1)
          ]),
          _: 2
        }, 1032, ["href"])
      ]),
      consumer: _withCtx((scope) => [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_el_avatar, {
            shape: "square",
            size: 60,
            src: scope.row.consumerHeadImgUrl
          }, null, 8, ["src"]),
          _createElementVNode("span", _hoisted_3, _toDisplayString(scope.row.consumerNickName), 1)
        ])
      ]),
      _: 1
    }, 8, ["contentTableConfig"])
  ]))
}
}

})